<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Pengurusan Pengguna"
  >
<w-flex justify-space-between class="mb4">
                    
                    <div class="xs3">
                        <w-input label="Nama" v-model="cari.name" name="name" />
                    </div>

                    <div class="xs3">
                        <w-input label="No. Kad Pengenalan" v-model="cari.no_id" name="no_id" />
                    </div>

                    <div class="xs3">
                       
                      <z-lookup label="Status" name="status" 
                        :options="[{label: 'Emel Belum Sah', value: 5}, {label: 'Baharu', value: 2}, {label: 'Kelulusan', value: 3}, {label: 'Tidak Aktif', value: 4}, {label: 'Aktif', value: 1}]" :sort="false" :cache="false" v-model="cari.status" />
                  </div>
                </w-flex>

               

            
            <div class="mt2 mb2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Kemaskini Pengguna
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="send"
      @success="success"
    >

    <!-- <w-form ref="form" v-model="dialog.valid" @validate="send" @success="success"> -->

    <z-input label="Name" v-model="form.name" name="name" :validators="[validators.required]" />

    <!-- <z-input class="mt3" label="Email" v-model="form.email" name="email" :validators="[validators.required]" /> -->

    <w-flex justify-space-between class="mb4 mt3">
              <z-lookup label="Kod Jabatan" name="jabatan" :url='service_utiliti+"lookup/jabatan"' :sort="false" :cache="false" v-model="form.jabatan_id"/>
    </w-flex>

    <z-input label="Jawatan" v-model="form.jawatan_user" name="jawatan" :validators="[validators.required]" />
    <br>
    <z-input label="No. Telefon" v-model="form.phone_number" name="phone_number" type="number" :validators="[validators.required]" />


     <!-- <div class="xs4">
        <h5 class="fw-semibold m0">
            Status
        </h5>
        <div class="fw-normal my1 fs-1"> 
            <w-switch class="mr6" v-model="form.status"></w-switch>
        </div>
      </div>
    </template>
    <template v-if="$zutil.can('ADMIN_BENDAHARI')">
    <z-input label="Name" v-model="form.name" name="name" :validators="[validators.required]" />
     <div class="xs4">
        <h5 class="fw-semibold m0">
            Lulus Pengguna
        </h5>
        <div class="fw-normal my1 fs-1"> 
            <w-switch class="mr6" v-model="form.status_login"></w-switch>
        </div>
      </div> -->
    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()" 
      >
        Simpan
      </w-button>

    </template>

    
  </w-dialog>
  
  <z-table
    ref="tbluser"
    title="Senarai Pengguna"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class=""
  >
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <w-icon xs>fal fa-pencil</w-icon>
      </template>
      <template v-else>
      {{ label }}
      </template>
      
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <template v-if="$zutil.can('ADMIN_JABATAN') || $zutil.can('ADMIN_BENDAHARI') || $zutil.can('SuperAdmin Jabatan')">
        <w-button class="fs-2 pr3 bs" bg-color="primary-dark1" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> 
        </w-button>
        <!-- <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> 
        </w-button> -->
        </template>
        <w-button 
          bg-color="info-dark1" 
          dark
          tile
          :route="$route('admin.user.show',item.id)"
          class="be fs-2"
        >
          <w-icon xs class="mr2">fal fa-eye</w-icon>  
        </w-button>
      </w-flex>
    </template>

    <template #item-cell.status="{ item, label, header, index }">
        <template v-if="item.status == 0">Emel Belum Sah</template>
        <template v-else-if="item.status == 1">Aktif</template>
        <template v-else-if="item.status == 2">Baharu</template>
        <template v-else-if="item.status == 3">Kelulusan</template>
        <template v-else-if="item.status == 4">Tidak Aktif</template>
    </template>
  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'admin.user',
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/admin/user' },
        { label: 'Pengguna', route: '/admin/user' }
      ],
                 cari : { name: '', status: '', no_id: ''},

      form: {
        id: 0,
        name: '',
        email: '',
        status: '',
        status_login: '',
        jabatan_id: '',
        phone_number: '',
        alamat_palsu: '',
        jawatan_user: '',
        loading: false,
      },
       
    }
  },
  methods: {
         search() {
             this.$inertia.visit(window.route('admin.user.index')+'?name='+this.cari.name+'&status='+this.cari.status+'&no_id='+this.cari.no_id , {preserveScroll:true})
            
        },
        reset(){
              this.cari = {name: '', status: ''}
              this.search()
        },

        send(){
        // this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
            this.$zcomm
                        .update(
                            this.resourceurl + ".update",
                            this.form.id,
                            this.form
                        )
            .then(res => {
                //update displayed record
                this.mapreturneddata(res)
                this.dialog.show = false;

              if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                this.$inertia.visit(this.$page.url)
            })
            .catch(err => {

            })
            .finally(() => {
                this.dialog.loading = false
                // this.dialog.show = false

            });
        },

  },
  watch: {

  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>